<template>
  <div class="container-products mb-100">

    <div class="banner-container bg-membresia"></div>
    <div class="d-block d-sm-block d-md-none">

      <!--
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/memb_1920x1080.jpg`"
      ></BannerTopMobile>-->
      <MenuMobile :icon="true" :nav="true" :show_user="true"></MenuMobile>
    </div>

    <steps-subscription
      :steps="steps"
    />

    <div :style="`${ products.length ? '' : 'margin-bottom: 50%'}`">
      <div v-for="(item, index) in products" :key="index">
        <ItemSubscripcion :product="item" :flavors="flavors"></ItemSubscripcion>
      </div>
    </div>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

  </div>

</template>

<script>
import HomeService from '@/services/home.service'
import ItemSubscripcion from '@/components/store/ItemSubscripcion'
import StepsSubscription from '@/components/store/StepsSubscription.vue'

export default {
  components: { ItemSubscripcion, StepsSubscription },
  data: () => ({
    url_banners_mobile: process.env.VUE_APP_URL_FILES,
    products: [],
    flavors: [],
    overlay: false,
    steps: [
      {
        icon: require('@/assets/store/iconos/membresia_paso1.svg'),
        title: '1. Elige tu itacate favorito'
      },
      {
        icon: require('@/assets/store/iconos/membresia_paso2.svg'),
        title: '2. Selecciona tu tipo de suscripción (mensual o quincenal)'
      },
      {
        icon: require('@/assets/store/iconos/membresia_paso3.svg'),
        title: '3. Escoge los sabores que quieras recibir. Puedes cambiarlos mes a mes'
      },
      {
        icon: require('@/assets/store/iconos/membresia_paso4.svg'),
        title: '4. Indicanos si tienes alguna alergia o si hay algo que no te guste, lo tomaremos en cuenta para las sorpresitas que te enviaremos cada vez'
      },
      {
        icon: require('@/assets/store/iconos/membresia_paso5.svg'),
        title: '5. Regístrate para guardar tu dirección en nuestro sistema y que puedas recibir tu itacate sin falta'
      },
      {
        icon: require('@/assets/store/iconos/membresia_paso6.svg'),
        title: '6. Ingresa tus datos de pago y listo! Ya eres parte de la familia Nieve de Olla'
      }
    ],
  }),
  methods: {
    async getProducts() {
      this.overlay = true
      const { data:res } = await HomeService.getSubscriptionProducts()
      this.products = res.products
      this.flavors = res.flavors
      setTimeout(() => {
        this.overlay = false
      },500)
    }
  },
  created() {
    this.getProducts()
  }
}
</script>

<style scoped>
.bg-membresia {
  background-image: url(
    'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_1920x1080.jpg'
  );
}

@media only screen and (min-width: 1024px) and (max-width: 1365px) {
  .bg-membresia {
    background-image: url(
      'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_1024x600.jpg'
    );
  }
}

/*  Tablets in portrait mode, large display smartphones landscape mode */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .bg-membresia {
    background-image: url(
      'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_1920x1080.jpg'
    );
  }
}

/*  Smartphones in landscape mode */
@media only screen and (min-width: 421px) and (max-width: 767px) {
  .bg-membresia {
    background-image: url(
      'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_1920x1080.jpg'
    );
  }
}

/*  Smartphones in portrait mode  */

@media only screen and (max-width: 420px) {
  .bg-membresia {
    background-image: url(
      'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_1920x1080.jpg'
    );
  }
}

@media only screen and (min-width: 1920px) and (max-width: 3000px) {
  .bg-membresia {
    background-image: url(
      'https://backend.nievedeolla.com.mx/public/images/membresias/membresia_8000x4500.jpg'
    );
  }
}

</style>
